import { useTreasuryAuthStore } from '../store/treasury-auth'
// import { useProjectStore } from '@/store/project'

export const useShowTreasuryAuthDialog = () => {
  const authStore = useTreasuryAuthStore()
  // const project = useProjectStore()

  authStore.changeJKAuthDialogVisible(true)
}
